/**
 * @author       calvin@zumper.com (Calvin Yau)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Filters reducer
 */

import { defaultFilters } from '@zcode/nr/es/shared/bizos/filter'
import { payloadReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { handleAction, handleActions } from 'redux-actions'
import {
  RESET_FILTERS,
  RESET_NON_ST_FILTERS,
  SET_FILTERS_CHANGED,
  SET_FILTER_MATCHING_COUNT,
  SET_PROPERTY_TYPE_COUNTS,
  UPDATE_FILTERS,
} from '../constants/index'
import { filterModalReducer } from './filterModalReducer'
import { default as listablesCountReducer } from './listablesCountReducer'
import { default as metaReducer } from './metaReducer'

const filtersReducer = combineReducers({
  // TODO: create a reducer for all the properties
  filters: handleActions(
    {
      [UPDATE_FILTERS]: (state, action) => {
        const { payload } = action
        if (payload) {
          const { filters, replace } = payload
          if (filters) {
            if (replace) {
              return filters
            }
            return { ...state, ...filters }
          }
        }
        return state
      },
      [RESET_FILTERS]: (filters) => {
        const { longTerm, shortTerm } = filters

        const newFilters = {
          ...defaultFilters,
          longTerm,
          shortTerm,
        }
        return newFilters
      },
      [RESET_NON_ST_FILTERS]: (filters) => {
        const { longTerm, shortTerm, bedrooms, minPrice, maxPrice } = filters

        const newFilters = {
          ...defaultFilters,
          longTerm,
          shortTerm,
          bedrooms,
          minPrice,
          maxPrice,
        }
        return newFilters
      },
    },
    defaultFilters
  ),
  filterModal: filterModalReducer,
  filtersChanged: handleAction(SET_FILTERS_CHANGED, payloadReducer, false),
  listablesCount: listablesCountReducer,
  matchingCount: handleActions(
    {
      [SET_FILTER_MATCHING_COUNT]: (_, action) => {
        return action.payload
      },
    },
    null
  ),
  propertyTypeCounts: handleActions(
    {
      [SET_PROPERTY_TYPE_COUNTS]: (_, action) => {
        return action.payload
      },
    },
    {}
  ),
  meta: metaReducer,
})

export default filtersReducer
